module.exports = __webpack_public_path__ + "static/media/list-icon.68ef6b11.svg";